import React from 'react';
import { Link } from 'react-router-dom';
import logo from 'assets/images/logo.jpg';
import { ROUTES } from '@lsgo/lsgo-common/constants/routes';

export default function NoPermission() {
    return (
        <div
            style={{
                width: '100%',
                height: '100vh',
                background: '#f5f5f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div
                style={{
                    width: '100%',
                    maxWidth: '500px',
                    margin: '0 auto',
                    padding: 80,
                    backgroundColor: '#fff',
                    textAlign: 'center',
                    borderRadius: 8,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                }}
            >
                <div>
                    <img src={logo} style={{ maxHeight: '140px', marginBottom: 20 }} alt="LSGO Logo" />
                </div>
                <h2 style={{ color: '#d32f2f', marginBottom: 16 }}>Insufficient Permissions</h2>
                <p style={{ color: '#666', marginBottom: 24, fontSize: '16px' }}>
                    You don't have the required permissions to access this page. Please contact your administrator if
                    you believe this is an error.
                </p>
                <div>
                    <Link
                        to={ROUTES.TEACHER.DASHBOARD.path}
                        style={{
                            display: 'inline-block',
                            padding: '12px 24px',
                            backgroundColor: '#1976d2',
                            color: '#fff',
                            textDecoration: 'none',
                            borderRadius: 4,
                            fontWeight: 500,
                        }}
                    >
                        Go to Dashboard
                    </Link>
                </div>
            </div>
        </div>
    );
}
